import mandatoryLoginSubscribe from "./mandatoryLoginSubscribe"
export default mandatoryLoginSubscribe;
